import React from "react"

import type { PolicyColumnKey } from "@common-shared/config/oneVerify/oneVerifyPoliciesColumns.config.ts"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config.ts"
import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import { OVERRIDES_CONFIG } from "../../../../config/overrides.config"
import { POLICIES_COLUMNS_CONFIG } from "../../../../config/policiesColumns.config"
import type {
    ICoverageOverrideFormData,
    IOverrideDefaultData,
} from "../../../../types/data.types.ts"
import { InlinedOverrideFormFieldComponent } from "../inlinedOverrideFormField.component"

export const BulkOverridesFormFieldComponent: React.FunctionComponent<
    IBulkOverridesFormFieldComponentProps
> = props => {
    const label = POLICIES_COLUMNS_CONFIG.columnsConfig[props.fieldKey].label

    const formTarget =
        OVERRIDES_CONFIG.bulkOverrides.allowedOverrideFields[props.fieldKey]

    const formValue = formTarget ? props.dataWatcher[formTarget] : undefined

    const showOverrideWarning =
        OVERRIDES_CONFIG.bulkOverrides.allowedOverrideFieldsConfirmationNotice.includes(
            props.fieldKey,
        ) && props.formItemHasValue(formValue)

    return (
        <div className={props.className}>
            <div className="flex items-start">
                <PrimaryText
                    className="w-[200px] mr-[16px] flex items-center flex-shrink-0 md:mr-[0px]"
                    typography="textSmall"
                >
                    {label}
                </PrimaryText>

                <div className="flex-1 relative">
                    <InlinedOverrideFormFieldComponent
                        fieldKey={props.fieldKey}
                        defaultData={props.defaultData}
                        fallback={null}
                        benefitStructureNotRequired={
                            props.benefitStructureNotRequired
                        }
                    />
                </div>
            </div>

            {showOverrideWarning ? (
                <PrimaryText
                    className="my-[6px]"
                    weight="semibold"
                    size={11}
                    lineHeight={12}
                    color={NIRVANA_COLORS.brand.vibrantPurple}
                >
                    Are you sure you want to bulk override the {label}?
                </PrimaryText>
            ) : null}
        </div>
    )
}

interface IBulkOverridesFormFieldComponentProps {
    className?: string
    fieldKey: PolicyColumnKey
    benefitStructureNotRequired?: boolean
    dataWatcher: ICoverageOverrideFormData
    defaultData: IOverrideDefaultData
    formItemHasValue: (item: any) => boolean
}
